import type { MonthlyCell, MonthlySessionCell } from "@/lib/types";
import type { SessionKey } from "@/lib/types";

const SESSION_ABBREV: Record<string, string> = {
  morning: "AM",
  morning_block: "AM",
  evening_block: "PM",
  whole_day: "Day",
};

const SESSION_TITLE: Record<string, string> = {
  morning: "Morning",
  morning_block: "Morning (9–1)",
  evening_block: "Evening (5–9)",
  whole_day: "Whole day",
};

/** Short label for shift legend / tooltips (AM, PM, Day). */
export function sessionAbbrev(
  session?: SessionKey | string | null,
  index = 0
): string {
  if (session && SESSION_ABBREV[session]) return SESSION_ABBREV[session];
  return index === 0 ? "AM" : "PM";
}

export function sessionTitle(
  session?: SessionKey | string | null,
  label?: string | null,
  index = 0
): string {
  if (label) return label;
  if (session && SESSION_TITLE[session]) return SESSION_TITLE[session];
  return index === 0 ? "Morning" : "Evening";
}

/** Sessions for one day — from `sessions[]` or a single legacy cell. */
export function getMonthlyDaySessions(
  cell: MonthlyCell | undefined
): MonthlySessionCell[] {
  if (!cell) return [];

  if (cell.sessions && cell.sessions.length > 0) {
    return cell.sessions;
  }

  if (cell.status === "pending") {
    return [];
  }

  return [
    {
      label: "",
      status: cell.status,
      late_minutes: cell.late_minutes,
      previous_status: cell.previous_status,
      holiday_name: cell.holiday_name,
    },
  ];
}

export function monthlyRowKey(row: {
  person_id: string;
  category?: string;
  shift_label?: string | null;
  shift_index?: number | null;
}): string {
  const shift =
    row.shift_label ??
    (row.shift_index != null ? `shift-${row.shift_index}` : "default");
  return `${row.person_id}-${row.category ?? "employee"}-${shift}`;
}
